
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";

import "../StyleBase/base.css"
import { auth, db, logout } from "../auth/UsersConfig/Authfirebase";
import { query, collection, getDocs, where } from "firebase/firestore";

function Dashboard() {
  const [user, loading, error] = useAuthState(auth);
  const [name, setName] = useState("");
  const navigate = useNavigate();

  /*Obtener datos del usuario
  const fetchUserName = async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();

      setName(data.name);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  */
  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/Login");

   // fetchUserName();
  }, [user, loading]);

  return (
    <div className="ContainerBody">



        <div><h1>Bienvenido {user?.email}</h1></div>

   
    </div>

  );
}

export default Dashboard;